module.exports = __webpack_public_path__ + "img/sompo-sigorta.ce82ec50.png";